module.exports = __webpack_public_path__ + "static/media/heroes_class.37eff662.svg";